import { PerksPage } from '@ltvco/refresh-lib/v1';
import { useEffect } from 'react';

export function RewardsPage() {
  useEffect(() => {
    document.title = 'Member Perks - NeighborWho';
  }, []);

  return <PerksPage />;
}
